function SvgIcon({ source }) {
    return <div dangerouslySetInnerHTML={{ __html: source }} />;
}

export default SvgIcon;